import { IconVideo } from "@dream/ui";
import { DateTime } from "luxon";
import type { ChipPerson } from "../lib/people.ts";
import { AvatarStack } from "./avatar-stack.tsx";

/**
 * Pill “Upcoming event” da frame Ofative (62:18653).
 *
 * Figma: 401×74, raio 16, padding 16, gap 16, sombra 0 4px 20px / 8%,
 * ícone 40, título 16/700, subtítulo 12/500 `#8E8E8E`, avatares 40 gap −16.
 */

export interface UpcomingOccurrence {
  deliverableId: string;
  title: string;
  startsAt: Date;
  clientName: string | null;
  assigneeName: string | null;
  people?: ChipPerson[];
}

export function UpcomingPill({
  occurrence,
  timezone,
  onOpen,
}: {
  occurrence: UpcomingOccurrence | null;
  timezone: string;
  onOpen: (deliverableId: string) => void;
}) {
  if (occurrence === null) return null;

  const start = DateTime.fromJSDate(occurrence.startsAt, { zone: timezone });
  const when = start.toFormat("HH:mm");
  const people =
    occurrence.people ??
    (occurrence.assigneeName !== null && occurrence.assigneeName !== ""
      ? [{ name: occurrence.assigneeName, imageUrl: null }]
      : []);

  return (
    <button
      type="button"
      data-testid="upcoming-pill"
      onClick={() => onOpen(occurrence.deliverableId)}
      className="dream-upcoming-pill dream-enter dream-float pointer-events-auto"
    >
      <span className="dream-upcoming-pill__icon" aria-hidden="true">
        <IconVideo className="size-6" />
      </span>
      <span className="dream-upcoming-pill__copy">
        <span className="dream-upcoming-pill__title">{occurrence.title}</span>
        <span className="dream-upcoming-pill__meta">
          Próximo evento
          {when !== "" ? ` · ${when}` : ""}
          {occurrence.clientName !== null ? ` · ${occurrence.clientName}` : ""}
        </span>
      </span>
      <AvatarStack people={people} size={40} className="dream-upcoming-pill__avatars" />
    </button>
  );
}
